import { lazy, Suspense, useEffect } from "react";
import { MarketingApp } from "../components/marketing/marketing-app";
import { normalizePath, pageMetadata } from "../lib/pages";
const ProductApp = lazy(() => import("../components/product/product-app"));
const DesignEditor = lazy(() => import("../components/editor/design-editor"));
export default function Home() {
  const path = normalizePath(window.location.pathname);
  useEffect(() => {
    const metadata = pageMetadata(path);
    document.title = metadata.title;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", metadata.description);
    if (window.location.hash) {
      try {
        document
          .getElementById(decodeURIComponent(window.location.hash.slice(1)))
          ?.scrollIntoView();
      } catch {
        /* Ignore malformed URL fragments. */
      }
    }
  }, [path]);
  return path === "/app" ? (
    <Suspense
      fallback={
        <main className="loading-state">
          <p>Opening your workspace…</p>
        </main>
      }
    >
      {new URLSearchParams(window.location.search).get("editor") === "1" ? (
        <DesignEditor />
      ) : (
        <ProductApp />
      )}
    </Suspense>
  ) : (
    <MarketingApp path={path} />
  );
}
